import { render, staticRenderFns } from "./ChangeSystemContent.vue?vue&type=template&id=33bf44bc"
import script from "./ChangeSystemContent.vue?vue&type=script&lang=js"
export * from "./ChangeSystemContent.vue?vue&type=script&lang=js"
import style0 from "./ChangeSystemContent.vue?vue&type=style&index=0&id=33bf44bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports